import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import commonEN from './locales/en/common.json';
import layoutEN from './locales/en/layout.json';
import dashboardEN from './locales/en/dashboard.json';
import authEN from './locales/en/auth.json';
import posEN from './locales/en/pos.json';
import orderEN from './locales/en/order.json';
import productEN from './locales/en/product.json';
import customerEN from './locales/en/customer.json';
import stockEN from './locales/en/stock.json';
import chatEN from './locales/en/chat.json';
import saleEN from './locales/en/sale.json';
import reportEN from './locales/en/report.json';
import userEN from './locales/en/user.json';
import pickupEN from './locales/en/pickup.json';
import fulfillmentEN from './locales/en/fulfillment.json';
import settingEN from './locales/en/setting.json';
import storeEN from './locales/en/store.json';
import deliveryFeeEN from './locales/en/delivery-fee.json';
import messageTemplateEN from './locales/en/message-template.json';
import mediaEN from './locales/en/media.json';
import facebookEN from './locales/en/facebook.json';

import commonKM from './locales/km/common.json';
import layoutKM from './locales/km/layout.json';
import dashboardKM from './locales/km/dashboard.json';
import authKM from './locales/km/auth.json';
import posKM from './locales/km/pos.json';
import orderKM from './locales/km/order.json';
import productKM from './locales/km/product.json';
import customerKM from './locales/km/customer.json';
import stockKM from './locales/km/stock.json';
import chatKM from './locales/km/chat.json';
import saleKM from './locales/km/sale.json';
import reportKM from './locales/km/report.json';
import userKM from './locales/km/user.json';
import pickupKM from './locales/km/pickup.json';
import fulfillmentKM from './locales/km/fulfillment.json';
import settingKM from './locales/km/setting.json';
import storeKM from './locales/km/store.json';
import deliveryFeeKM from './locales/km/delivery-fee.json';
import messageTemplateKM from './locales/km/message-template.json';
import mediaKM from './locales/km/media.json';
import facebookKM from './locales/km/facebook.json';

// Configure resources
const resources = {
  en: {
    common: commonEN,
    layout: layoutEN,
    dashboard: dashboardEN,
    auth: authEN,
    pos: posEN,
    order: orderEN,
    product: productEN,
    customer: customerEN,
    stock: stockEN,
    chat: chatEN,
    sale: saleEN,
    report: reportEN,
    user: userEN,
    pickup: pickupEN,
    fulfillment: fulfillmentEN,
    setting: settingEN,
    store: storeEN,
    deliveryFee: deliveryFeeEN,
    messageTemplate: messageTemplateEN,
    media: mediaEN,
    facebook: facebookEN,
  },
  km: {
    common: commonKM,
    layout: layoutKM,
    dashboard: dashboardKM,
    auth: authKM,
    pos: posKM,
    order: orderKM,
    product: productKM,
    customer: customerKM,
    stock: stockKM,
    chat: chatKM,
    sale: saleKM,
    report: reportKM,
    user: userKM,
    pickup: pickupKM,
    fulfillment: fulfillmentKM,
    setting: settingKM,
    store: storeKM,
    deliveryFee: deliveryFeeKM,
    messageTemplate: messageTemplateKM,
    media: mediaKM,
    facebook: facebookKM,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'km'],
    defaultNS: 'common',
    ns: [
      'common',
      'layout',
      'dashboard',
      'auth',
      'pos',
      'order',
      'product',
      'customer',
      'stock',
      'chat',
      'sale',
      'report',
      'user',
      'pickup',
      'fulfillment',
      'setting',
      'store',
      'deliveryFee',
      'messageTemplate',
      'media',
      'facebook',
    ],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
